import Login from '@/components/Login.vue';

const routes =

  {
    path: '/login',
    component: Login,
    name: 'Login',
    meta:{
      requiredAuth: false
    }
  }

export default routes;
